import { useEffect, useRef } from 'react'

export const useDragScroll = (isHorizontal = true) => {
	const ref = useRef(null)
	const isDown = useRef(false)
	const isDragging = useRef(false)
	const suppressNextClick = useRef(false)
	const startPos = useRef(0)
	const startScroll = useRef(0)
	const DEAD_ZONE = 5

	useEffect(() => {
		const el = ref.current
		if (!el) return

		const onPointerDown = (e) => {
			isDown.current = true
			isDragging.current = false
			suppressNextClick.current = false
			startPos.current = isHorizontal ? e.clientX : e.clientY
			startScroll.current = isHorizontal ? el.scrollLeft : el.scrollTop
		}

		const onPointerMove = (e) => {
			if (!isDown.current) return
			const cur = isHorizontal ? e.clientX : e.clientY
			const delta = cur - startPos.current

			if (!isDragging.current && Math.abs(delta) < DEAD_ZONE) return

			if (!isDragging.current) {
				isDragging.current = true
				el.setPointerCapture?.(e.pointerId)
			}

			e.preventDefault()

			if (isHorizontal) el.scrollLeft = startScroll.current - delta
			else el.scrollTop = startScroll.current - delta
		}

		const onPointerUp = (e) => {
			if (isDragging.current) {
				suppressNextClick.current = true
			}
			isDown.current = false
			isDragging.current = false
			try { el.releasePointerCapture?.(e.pointerId) } catch {}
		}

		const onClick = (e) => {
			if (suppressNextClick.current) {
				e.stopPropagation()
				e.preventDefault()
				suppressNextClick.current = false
			}
		}

		el.addEventListener('pointerdown', onPointerDown)
		el.addEventListener('pointermove', onPointerMove, { passive: false })
		el.addEventListener('pointerup', onPointerUp)
		el.addEventListener('pointercancel', onPointerUp)
		el.addEventListener('pointerleave', onPointerUp)
		el.addEventListener('click', onClick, true)

		return () => {
			el.removeEventListener('pointerdown', onPointerDown)
			el.removeEventListener('pointermove', onPointerMove)
			el.removeEventListener('pointerup', onPointerUp)
			el.removeEventListener('pointercancel', onPointerUp)
			el.removeEventListener('pointerleave', onPointerUp)
			el.removeEventListener('click', onClick, true)
		}
	}, [isHorizontal])

	return ref
}